import styled from "styled-components";
import { Layout } from "antd";

const StyledLayout = styled(Layout)`
    min-height: 100vh;
    position: relative;
    max-width: 1440px;
    margin: 0 auto;

    //contain: content;
`;

export const S = {
  StyledLayout
};